import { AUTH_RESET_2FA, AUTH_RESET_2FA_FAILED, AUTH_RESET_2FA_SUCCESS } from './types';
import { apiAction } from '../../api/actions';

export function reset2FA(email, onSuccess, onFailure) {
  return apiAction({
    resource: '/su/auth/reset-2fa',
    method: 'POST',
    data: {
      email
    },
    onSuccess: (data) => onSuccessReset2FA(data, onSuccess),
    onFailure: (error) => onFailedReset2FA(error, onFailure),
    carry: {
      label: AUTH_RESET_2FA
    },
  });
}

function onSuccessReset2FA(data, onSuccess) {
  onSuccess();
  return {
    type: AUTH_RESET_2FA_SUCCESS,
    payload: data
  };
}

function onFailedReset2FA(error, onFailure) {
  onFailure();
  return {
    type: AUTH_RESET_2FA_FAILED,
    payload: {
      error
    }
  };
}
